export default "__VITE_ASSET__75d2ea17__"